var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Can pay on hold')},model:{value:(_vm.canPayOnHold),callback:function ($$v) {_vm.canPayOnHold=$$v},expression:"canPayOnHold"}})}
var staticRenderFns = []

export { render, staticRenderFns }